import vueWrapper from "../../utils/vue-wrapper"
import app from './app.vue';

export default () => {
  vueWrapper(app, "collection-body", "#collectionBodyData")
}